import { useCallback } from "react";
import type { PersonalInfoFormValues } from "components/forms/personal-info-section/personal-info-section.component";
import { useUpdateUserProfile } from "./use-update-user-profile.hook";

export const useUpdatePersonalInfo = () => {
  const { updateUserProfile, isLoading } = useUpdateUserProfile();

  const updatePersonalInfo = useCallback(
    async (values: PersonalInfoFormValues) => {
      let isoDateOfBirth = values.dateOfBirth;
      if (values.dateOfBirth) {
        if (values.dateOfBirth.includes("/")) {
          const [month, day, year] = values.dateOfBirth.split("/");
          isoDateOfBirth = `${year}-${month.padStart(2, "0")}-${day.padStart(
            2,
            "0"
          )}T00:00:00Z`;
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(values.dateOfBirth)) {
          isoDateOfBirth = `${values.dateOfBirth}T00:00:00Z`;
        }
      }

      await updateUserProfile({
        first_name: values.firstName,
        last_name: values.lastName,
        preferred_first_name: values.preferredName,
        date_of_birth: isoDateOfBirth,
        sex: values.sex,
      });
    },
    [updateUserProfile]
  );

  return { updatePersonalInfo, isLoading };
};
